import { Intent } from "@blueprintjs/core";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { RouterProps, withRouter } from "react-router";
import { compose } from "recompose";
import NotificationList from "~/components/Notifications/NotificationList";
import { shopConfig } from "~/helpers/shopConfig";

export interface INotificationDate {
  day: number;
  month: number;
  year?: number;
  hour?: number;
  minute?: number;
  second?: number;
}

export interface INotification {
  startDate: INotificationDate;
  endDate: INotificationDate;

  key: string;
  onlyForPage?: string[];
  title: string;
  description: string;
  intent: Intent;
}

class NotificationsContainer extends React.Component<
  WithTranslation & RouterProps
> {
  public render() {
    const {
      t,
      history: { location }
    } = this.props;

    const notifications: INotification[] =
      t("notifications", { returnObjects: true, ...shopConfig }) || [];

    const today = new Date();
    const activeNotifications = notifications.filter(notification => {
      const { startDate, endDate } = this.notificationDates(
        notification.startDate,
        notification.endDate
      );
      return (
        today >= startDate &&
        today <= endDate &&
        (notification.onlyForPage
          ? notification.onlyForPage.includes(location.pathname)
          : true)
      );
    });

    if (!activeNotifications.length) {
      return null;
    }

    return <NotificationList notifications={activeNotifications} />;
  }

  private notificationDates(
    startDate: INotificationDate,
    endDate: INotificationDate
  ) {
    if (startDate.year && endDate.year) {
      return {
        endDate: this.normalizeNotificationDate(endDate),
        startDate: this.normalizeNotificationDate(startDate)
      };
    }

    // If it starts in December (12) and ends in January (1), we set the date to next year
    if (startDate.month > endDate.month) {
      const today = new Date();
      const startYear =
        today.getMonth() + 1 < startDate.month
          ? today.getFullYear() - 1
          : today.getFullYear();

      return {
        endDate: this.normalizeNotificationDate(endDate, startYear + 1),
        startDate: this.normalizeNotificationDate(startDate, startYear)
      };
    }

    return {
      endDate: this.normalizeNotificationDate(endDate),
      startDate: this.normalizeNotificationDate(startDate)
    };
  }

  private normalizeNotificationDate(
    notificationDate: INotificationDate,
    yearOverride?: number
  ) {
    const normalizedDate = new Date();

    normalizedDate.setDate(notificationDate.day);
    normalizedDate.setMonth(notificationDate.month - 1);
    if (notificationDate.year) {
      normalizedDate.setFullYear(notificationDate.year);
    }
    if (yearOverride) {
      normalizedDate.setFullYear(yearOverride);
    }

    if (notificationDate.hour) {
      normalizedDate.setHours(notificationDate.hour);
    }
    if (notificationDate.minute) {
      normalizedDate.setMinutes(notificationDate.minute);
    }
    if (notificationDate.second) {
      normalizedDate.setSeconds(notificationDate.second);
    }

    return normalizedDate;
  }
}

export default compose(
  withRouter,
  withTranslation("notificationsBlock")
)(NotificationsContainer);



// WEBPACK FOOTER //
// ./src/containers/Notifications/NotificationsContainer.tsx